import { WEB_COMPONENT_TARGETS_GRID } from '../../../../../webcomponents.constants';
import { TargetsGridWebComponent } from './component/TargetsGridWebComponent';

window.customElements.define(WEB_COMPONENT_TARGETS_GRID, TargetsGridWebComponent);

export { TargetsGridWebComponent };
